export default "__VITE_ASSET__BXSWYDNe__"